"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProxyContracts = exports.suffixProxy = exports.stripProxy = exports.RegisteredContracts = exports.AllContracts = exports.CeloContract = void 0;
var CeloContract;
(function (CeloContract) {
    CeloContract["Accounts"] = "Accounts";
    CeloContract["Attestations"] = "Attestations";
    CeloContract["BlockchainParameters"] = "BlockchainParameters";
    CeloContract["DoubleSigningSlasher"] = "DoubleSigningSlasher";
    CeloContract["DowntimeSlasher"] = "DowntimeSlasher";
    CeloContract["Election"] = "Election";
    CeloContract["EpochRewards"] = "EpochRewards";
    CeloContract["ERC20"] = "ERC20";
    CeloContract["Escrow"] = "Escrow";
    CeloContract["Exchange"] = "Exchange";
    CeloContract["ExchangeEUR"] = "ExchangeEUR";
    CeloContract["ExchangeBRL"] = "ExchangeBRL";
    CeloContract["FeeCurrencyWhitelist"] = "FeeCurrencyWhitelist";
    CeloContract["Freezer"] = "Freezer";
    CeloContract["GasPriceMinimum"] = "GasPriceMinimum";
    CeloContract["GoldToken"] = "GoldToken";
    CeloContract["Governance"] = "Governance";
    CeloContract["GrandaMento"] = "GrandaMento";
    CeloContract["LockedGold"] = "LockedGold";
    CeloContract["MetaTransactionWallet"] = "MetaTransactionWallet";
    CeloContract["MetaTransactionWalletDeployer"] = "MetaTransactionWalletDeployer";
    CeloContract["MultiSig"] = "MultiSig";
    CeloContract["Random"] = "Random";
    CeloContract["Registry"] = "Registry";
    CeloContract["Reserve"] = "Reserve";
    CeloContract["SortedOracles"] = "SortedOracles";
    CeloContract["StableToken"] = "StableToken";
    CeloContract["StableTokenEUR"] = "StableTokenEUR";
    CeloContract["StableTokenBRL"] = "StableTokenBRL";
    CeloContract["TransferWhitelist"] = "TransferWhitelist";
    CeloContract["Validators"] = "Validators";
})(CeloContract = exports.CeloContract || (exports.CeloContract = {}));
exports.AllContracts = Object.keys(CeloContract);
var AuxiliaryContracts = [
    CeloContract.MultiSig,
    CeloContract.MetaTransactionWalletDeployer,
    CeloContract.MetaTransactionWallet,
    CeloContract.ERC20,
];
exports.RegisteredContracts = exports.AllContracts.filter(function (v) { return !AuxiliaryContracts.includes(v); });
var stripProxy = function (contract) { return contract.replace('Proxy', ''); };
exports.stripProxy = stripProxy;
var suffixProxy = function (contract) {
    return contract.endsWith('Proxy') ? contract : contract + "Proxy";
};
exports.suffixProxy = suffixProxy;
exports.ProxyContracts = exports.AllContracts.map(function (c) { return (0, exports.suffixProxy)(c); });
//# sourceMappingURL=base.js.map